module.exports = __webpack_public_path__ + "static/media/new.aa5392b9.jpg";